import { PRODUCT_TYPES_VALUES } from 'constants/dictionaries';

import { useAppSelector } from 'shared/lib';

import { selectCreditPurposeInfoData } from 'entities/creditForm';

const PRODUCT_TYPE_ANALYTICS_MAP = {
  [PRODUCT_TYPES_VALUES.CREDIT_CARD]: 'Кредитные карты',
  [PRODUCT_TYPES_VALUES.MICRO_CREDIT]: 'Займы',
  [PRODUCT_TYPES_VALUES.CREDIT]: 'Кредиты наличными',
} as const;

export const useAnalyticsProductType = () => {
  const { selectedProductType, purpose } = useAppSelector(selectCreditPurposeInfoData);

  if (selectedProductType === PRODUCT_TYPES_VALUES.CREDIT) {
    return purpose?.value === 'RefinanceCredit' ? 'Рефинансирование' : PRODUCT_TYPE_ANALYTICS_MAP[selectedProductType];
  }

  return selectedProductType ? PRODUCT_TYPE_ANALYTICS_MAP[selectedProductType] : 'Кредиты наличными';
};
